<div id="header" class="layout-topbar">

    <a href="#" class="layout-menubutton" [ngClass]="{'layout-menubutton-active': app.menuActive}" (click)="app.onMenuButtonClick($event)">
        <div class="layout-menubutton-icon"></div>
    </a>

    <div class="layout-topbar-grid ui-g">

        <div class="layout-topbar-grid-column ui-g-6">
            <app-menu [reset]="app.resetMenu"></app-menu>
        </div>

        <div class="layout-topbar-grid-column layout-topbar-grid-column-fixed ui-g-6" style="text-align: right;">
           
            <div class="ui-g-9" style="text-align: right;" >
                <div class="ui-g-8"  >
                <span class="color--white" style="padding-right: 0.5em">Company:</span>
            </div>
            <div class="ui-g-4"  >
            <a href="#">
                <p-dropdown id ="inputCompany"  [(ngModel)]="company" [options]="companies" optionLabel="name" [autoDisplayFirst]=false
                dataKey="id" (onChange)="onChange($event)"></p-dropdown>
            </a>
        </div>
        
        </div>
        <div class="ui-g-3" style="text-align: right;" >
            <label class="p-pl-3" style='color: #fff; cursor: pointer; padding-right: 0.5em' [textContent]="getName()" (click)="app.onTopbarUserMenuButtonClick($event)"></label>
            <a href="#" class="profile-menu-button" (click)="app.onTopbarUserMenuButtonClick($event)">
                <img id="profilePhoto" src="/assets/layout/images/loader.gif" />
            </a>
            <ul class="layout-profile-menu fadeInDown" [ngClass]="{'layout-profile-menu-active': app.topbarUserMenuActive}" style="text-align: left;">
                <li role="menuitem">
                    <a class="ripplelink" (click)="onProfil()">
                        <i class="material-icons">account_circle</i>
                        <span>Account</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a class="ripplelink" (click)="onLogOut()">
                        <i class="material-icons">cancel</i>
                        <span>Log Off</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    </div>

</div>
